import React, { useState, useEffect } from "react";
import { makeStyles, Typography, Grid, Link, Button } from "@material-ui/core/";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { useSelector, useDispatch } from "react-redux";
import loginStyle from "./loginItems.module.css";
import Backdrop from "../../Backdrop";
import Aux from "../../../hoc/Auxilliary";
import logo from "../../../assests/authLogo.png";
import {
  loginRequest,
  isLoggedInUpdate,
  setErrorMessage,
} from "../../../reduxSlices/loginSlice";
import Input from "../../Ui/input";
import { isObjectEmpty } from "../../../utils/general";
import SnackBar from "../../SnackBar";
import PasswordRestModal from "../../ForgotPassword";
import localizedStrings from "../../../utils/localize";
import "../../../index.css";
import { clearPortalMessageCache } from "../../../utils/portalMessageCache";

const useStyle = makeStyles((theme) => ({
  container: {
    margin: "0",
    padding: "1rem 0",
  },
  itemContainer: {
    margin: "0 auto",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  logoAvatar: {
    width: "30%",
    height: "auto",
  },
  formControl: {
    display: "flex",
    width: "100%",
    alignItems: "center",
  },
  bottomContainer: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1rem",
  },
  bottomContainernotes: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1rem",
  },
}));

const LoginItems = (props) => {
  const classes = useStyle(props);
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(true);
  const loginRequestData = useSelector(
    (state) => state.loginRequest.loginRequestData,
  );

  const errorMessage = useSelector((state) => state.loginRequest.errorMessage);
  window.localStorage.removeItem("email");
  if (!isObjectEmpty(loginRequestData)) {
    let responseData = loginRequestData;
    clearPortalMessageCache();
    window.localStorage.setItem("x-auth-token", responseData.token);
    window.localStorage.setItem("x-auth-fullname", responseData.fullname);
    window.localStorage.setItem("x-auth-contactId", responseData.contactid);
    window.localStorage.setItem("x-auth-email", responseData.emailaddress1);
    window.localStorage.setItem("x-auth-mobile", responseData.mobilephone);
    window.localStorage.setItem("isUserLoggedIn", true);
    dispatch(isLoggedInUpdate(true));
    props.history.push({
      pathname: "/home",
    });
  }
  const dataFetchingStatus = useSelector(
    (state) => state.loginRequest.dataFetchingStatus,
  );
  const [displayMessage, setDisplayMessage] = useState("");

  // const errorMessage = useSelector((state) => state.loginRequest.errorMessage);

  const [loginData, setLoginData] = useState({
    form: {
      email: {
        elementType: "input",
        elementConfig: {
          type: "email",
          label: localizedStrings.login.email,
          autoComplete: "email",
          name: "email",
          required: true,
          autoFocus: true,
          fullWidth: true,
        },
        icon: <MailOutlineIcon style={{ color: "#959595" }} />,
        value: "",
      },
      password: {
        elementType: "input",
        elementConfig: {
          type: "password",
          label: localizedStrings.login.password,
          autoComplete: "current-password",
          name: "password",
          required: true,
          fullWidth: true,
        },
        icon: <LockOutlinedIcon style={{ color: "#959595" }} />,
        value: "",
      },
    },
  });
  const [modalState, setModalState] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState({
    status: false,
    message: "",
  });

  const language = useSelector((state) => state.language.language);
  localizedStrings.setLanguage(language);

  useEffect(() => {
    if (
      loginData.form.email.value !== "" &&
      loginData.form.password.value !== ""
    ) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [loginData]);

  useEffect(() => {
    localizedStrings.setLanguage(language);
    setLoginData((prev) => {
      const newObbj = { ...prev };
      newObbj.form.email.elementConfig.label = localizedStrings.login.email;
      newObbj.form.password.elementConfig.label =
        localizedStrings.login.password;
      return newObbj;
    });
  }, [language]);

  const textFieldChangeHandler = (event) => {
    const { name: eventName, value } = event.target;
    const eventValue = value.trim();

    // Update the form data
    const formData = {
      ...loginData.form,
      [eventName]: { ...loginData.form[eventName], value: eventValue },
    };

    if (eventName === "email") {
      const helperMsg1 = localizedStrings.login.emailhelpermsg1;
      const helperMsg2 = localizedStrings.login.emailhelpermsg2;
      const helperMsg3 = localizedStrings.login.emailhelpermsg3;
      let customMessage = "";

      if (!eventValue.includes("@")) {
        // Missing '@'
        customMessage =
          localizedStrings._language === "en"
            ? `${helperMsg1} ${eventValue} ${helperMsg2}`
            : `${helperMsg1} ${helperMsg2} ${eventValue}`;
      } else {
        const [localPart, domainPart] = eventValue.split("@");

        if (
          !domainPart ||
          domainPart.endsWith(".") ||
          domainPart.startsWith(".")
        ) {
          // Invalid domain part
          customMessage =
            localizedStrings._language === "en"
              ? `${helperMsg3} ${eventValue}`
              : `${helperMsg3} ${eventValue}`;
        } else if (localPart.startsWith(".") || localPart.endsWith(".")) {
          // Invalid local part
          customMessage =
            localizedStrings._language === "en"
              ? `${helperMsg3} ${eventValue}`
              : `${helperMsg3} ${eventValue}`;
        }
      }

      event.target.setCustomValidity(customMessage);
    } else {
      event.target.setCustomValidity(""); // Clear the message when valid
    }

    setLoginData((prevState) => ({
      ...prevState,
      form: formData,
    }));
  };

  // console.log("loginRequestData",loginRequestData,errorMessage,showSnackBar)
  useEffect(() => {
    if (!isObjectEmpty(errorMessage) && errorMessage !== undefined) {
      let status = { ...showSnackBar };
      status.status = true;
      status.message = errorMessage.error;
      setShowSnackBar(status);
    }
  }, [errorMessage]);

  const handleSubmit = (event) => {
    event.preventDefault();
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
    const formData = {};
    for (let formDataIdentifier in loginData.form) {
      formData[formDataIdentifier] = loginData.form[formDataIdentifier].value;
    }
    dispatch(loginRequest(formData));
  };

  let formDataElementArray = [];

  for (let key in loginData.form) {
    formDataElementArray.push({
      id: key,
      config: loginData.form[key],
    });
  }
  const showModal = () => {
    setModalState(true);
  };

  let form = (
    <form className={classes.form} onSubmit={handleSubmit}>
      {formDataElementArray.map((data, index) => {
        return (
          <Input
            key={index}
            inputType={data.config.elementType}
            elementConfig={data.config.elementConfig}
            value={data.config.value}
            changed={(event) => textFieldChangeHandler(event)}
            icon={data.config.icon}
          />
        );
      })}
      <div className={classes.formControl}>
        <Link variant="body2" style={{ cursor: "pointer" }} onClick={showModal}>
          {localizedStrings.login.forgotPassword}?
        </Link>
      </div>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={disabled}
        style={{
          backgroundColor: disabled ? "#808080ad" : "#0b9ec1",
          color: "#ffffff",
        }}
      >
        {localizedStrings.login.signIn}
      </Button>
      <Grid container className={classes.bottomContainer}>
        <Typography>
          <span> {localizedStrings.login.registerMessageOne}?</span>
          <Link
            variant="body2"
            style={{ cursor: "pointer", marginLeft: "4px" }}
            onClick={() => {
              props.history.push("/register");
            }}
          >
            {localizedStrings.login.registerMessageTwo}
          </Link>
        </Typography>
      </Grid>
      <Grid container className={classes.bottomContainernotes}>
        {localizedStrings.login.notes} <br />• {localizedStrings.login.notes1}
        <br />• {localizedStrings.login.notes2}
        <br />• {localizedStrings.login.notes3}
        <br />
        <span>
          • {localizedStrings.login.notes4}{" "}
          <a href="mailto:admissions@ustboniface.ca">
            admissions@ustboniface.ca
          </a>{" "}
          {localizedStrings.login.notes5}
        </span>
      </Grid>
    </form>
  );

  const handleClose = () => {
    let status = { ...showSnackBar };
    status.status = false;
    setShowSnackBar(status);
    dispatch(setErrorMessage({}));
  };
  const handleModalClose = () => {
    setModalState(false);
  };

  useEffect(() => {
    if (showSnackBar.message === "Invalid Username or Password") {
      setDisplayMessage(localizedStrings.general.loginerrorMessage);
    } else if (showSnackBar.message === "Something Went Wrong") {
      setDisplayMessage(localizedStrings.general.somethingwentwrong);
    } else {
      setDisplayMessage(showSnackBar.message);
    }
  }, [showSnackBar]);

  return (
    <Aux>
      <SnackBar
        open={showSnackBar.status}
        message={displayMessage}
        handleClose={handleClose}
      />
      <PasswordRestModal open={modalState} onClose={handleModalClose} />
      <Backdrop show={dataFetchingStatus} />
      <div className={loginStyle.loginContainer}>
        <div className={loginStyle.loginContent}>
          <div className={classes.logoAvatar}>
            <img src={logo} width="100%" alt="logo" />
          </div>
          <Typography component="h1" variant="h5">
            {localizedStrings.login.signIn}
          </Typography>
          <br/>
           <Typography style={{fontSize:"16px",justifyContent:'left'}}>
            {localizedStrings.login.signInBelowText}
          </Typography>
          {form}
        </div>
      </div>
    </Aux>
  );
};

export default LoginItems;
